import { Component, inject, OnInit } from '@angular/core';
import { Navbar } from './components/navbar/navbar';
import { Hero } from './components/hero/hero';
import { Solutions } from './components/solutions/solutions';
import { Offshore } from './components/offshore/offshore';
import { Offline } from './components/offline/offline';
import { Detections } from './components/detections/detections';
import { Events } from './components/events/events';
import { UseCases } from './components/use-cases/use-cases';
import { Technology } from './components/technology/technology';
import { About } from './components/about/about';
import { Reasons } from './components/reasons/reasons';
import { Testimonials } from './components/testimonials/testimonials';
import { Clients } from './components/clients/clients';
import { Footer } from './components/footer/footer';
import { TranslationService } from './services/translation.service';

@Component({
  selector: 'app-root',
  imports: [Navbar, Hero, Solutions, Offshore, Offline, Detections, Events, UseCases, Technology, About, Reasons, Testimonials, Clients, Footer],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  ts = inject(TranslationService);

  ngOnInit() { this.ts.init(); }
}
